import React from 'react';

function BackButtonContainer({ resetChat, hasMore, showPrevious, loadMoreMovies, showPreviousMovies }) {
  return (
    <div id="backButtonContainer" className="button-group">
      {showPrevious && (
        <button className="more-btn" onClick={showPreviousMovies}>
          ← Previous Movies
        </button>
      )}
      
      <button className="back-btn" onClick={resetChat}>
        Try a different movie
      </button>
      
      {hasMore && (
        <button className="more-btn" onClick={loadMoreMovies}>
          Show More Movies →
        </button>
      )}
    </div>
  );
}

export default BackButtonContainer;
